<template>
  <div class='massLoss-report'>
    <div class='baseInfo'>
      <div class='baseInfoContent'>
        <el-form :model='modifyData' label-width='150px' label-position='right' :rules='rules'
                 ref='ruleForm' class='demo-ruleForm'>
          <div-border label='质损上报'>
            <div>
              <el-form-item label='运输方式:' prop='taskMode'>
                <el-radio-group v-model='modifyData.taskMode'
                                @change='resetForm(modifyData.taskMode)'>
                  <el-radio :label='0'>公路供应商</el-radio>
                  <el-radio :label='1'>水路供应商</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-if='modifyData.taskMode===0' label='选择车牌号:' prop='carNum'>
                <el-select v-model='modifyData.carNum' filterable size='small' placeholder='请选择车牌号'
                           @change='setDriverInfo'>
                  <el-option v-for='(item,index) in carNumList' :key='index' :label='item.truckName'
                             :value='item.id'></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if='modifyData.carNum&&modifyData.taskMode===0' class='driver-info'>
                <span>司机姓名:{{ modifyData.driver }}</span>
                <span>司机电话:{{ modifyData.phone }}</span>
              </el-form-item>
              <el-form-item v-if='modifyData.taskMode===1' label='选择船名:' prop='shipNum'>
                <el-select v-model='modifyData.shipNum' filterable size='small' placeholder='请选择船名'
                           @change='setDriverInfo'>
                  <el-option v-for='(item,index) in shipNumList' :key='index' :label='item.shipName'
                             :value='item.id'></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if='modifyData.shipNum&&modifyData.taskMode===1' class='ship-info'>
                <span>船长姓名:{{ modifyData.driver }}</span>
                <span>船长电话:{{ modifyData.phone }}</span>
              </el-form-item>
              <el-form-item label='质损时间:' prop='massLossTime'>
                <el-date-picker v-model='modifyData.massLossTime' type='datetime'
                                placeholder='选择日期时间'
                                size='small' value-format='yyyy-MM-dd HH:mm:ss' />
              </el-form-item>
              <el-form-item label='质损类型:' prop='typeId'>
                <el-select v-model='modifyData.typeId' filterable size='small'
                           placeholder='请选择质损类型'>
                  <el-option v-for='item in massLossType' :key='item.id' :label='item.classaName'
                             :value='item.id'></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label='质损部位:' prop='partId'>
                <el-select v-model='modifyData.partId' filterable size='small'
                           placeholder='请选择质损位置'>
                  <el-option v-for='item in massLossPart' :key='item.id' :label='item.classaName'
                             :value='item.id'></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label='质损部位详细说明:' prop='detailDesc'>
                <el-input
                  type='textarea'
                  :autosize='{ minRows: 4, maxRows: 18}'
                  placeholder='请输入质损部位详细说明'
                  v-model='modifyData.detailDesc' size='small'>
                </el-input>
              </el-form-item>
              <el-form-item label='质损情况:' prop='situation'>
                <el-input placeholder='请输入质损情况' v-model='modifyData.situation' size='small' />
              </el-form-item>
            </div>
          </div-border>
          <div-border label='选择质损车' class='div-border'>
            <el-form-item label='输入车架号:' label-width='100px'>
              <el-input v-model='searchParams.frameNumber' class='car-input' size='small'
                        placeholder='请输入车架号' />
              <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
            </el-form-item>
            <el-table
              v-loading='tableLoad'
              :data='tableData'
              class='car-table'
              max-height='400'
              border
              @row-click='singleElection'
              :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
              :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
              highlight-current-row>
              <el-table-column align='center' width='55' label='选择'>
                <template slot-scope='scope'>
                  <!-- 可以手动的修改label的值，从而控制选择哪一项 -->
                  <el-radio class='radio' v-model='templateSelection' :label='scope.row.id' />
                </template>
              </el-table-column>
              <el-table-column prop='batchNumber' label='批次号' align='center' show-overflow-tooltip
                               min-width='150' />
              <el-table-column prop='waybillNo' label='运单号' align='center' show-overflow-tooltip
                               min-width='150' />
              <el-table-column prop='frameNumber' label='车架号' align='center' show-overflow-tooltip
                               min-width='150' />
              <el-table-column label='装车地' align='center' show-overflow-tooltip
                               min-width='150'>
                <template slot-scope='scope'>
                  {{ scope.row.startType ? scope.row.startPortName : scope.row.startName }}
                </template>
              </el-table-column>
              <el-table-column label='交车地' align='center' show-overflow-tooltip
                               min-width='150'>
                <template slot-scope='scope'>
                  {{ scope.row.deliveryType ? scope.row.deliveryPortName : scope.row.deliveryName }}
                </template>
              </el-table-column>
              <el-table-column prop='loadingDate' label='装车时间' align='center' show-overflow-tooltip
                               min-width='150'>
                <template slot-scope='scope'>
                  {{ scope.row.loadingDate ? scope.row.loadingDate.slice(0, 10) : '--' }}
                </template>
              </el-table-column>
              <el-table-column prop='deliveryDate' label='交车时间' align='center' show-overflow-tooltip
                               min-width='150'>
                <template slot-scope='scope'>
                  {{ scope.row.deliveryDate ? scope.row.deliveryDate.slice(0, 10) : '--' }}
                </template>
              </el-table-column>
            </el-table>
            <div class='paginationContainer'>
              <el-pagination
                background
                :page-sizes='[10, 20, 30, 40]'
                layout='total, sizes, prev, pager, next, jumper'
                :total='tableTotal'
                @size-change='contractSizeChange'
                @current-change='contractCurrentChange'
                :current-page.sync='searchParams.page'
                :page-size='searchParams.rows'
              />
            </div>
          </div-border>
          <div-border label='上传图片'>
            <div>
              <el-form-item prop='img' label-width='50px'>
                <div class='imgUp'>
                  <div class='imgLength'><span>{{ img.length }}/5</span></div>
                  <el-upload
                    ref='upload'
                    list-type='picture-card'
                    :action='uploadUrl'
                    accept='image/png, image/jpeg, image/jpeg, image/bmp, image/gif'
                    :before-upload='beforeAvatarUpload'
                    :on-change='uploadChange'
                    :on-remove='handleRemove'
                    :on-preview='handlePictureCardPreview'
                    :file-list='img'
                    :limit='5'>
                    <i class='el-icon-plus' />
                  </el-upload>
                </div>
              </el-form-item>
              <el-dialog :visible.sync='dialogVisible' append-to-body>
                <img width='100%' :src='dialogImageUrl' alt=''>
              </el-dialog>
            </div>
          </div-border>
        </el-form>
        <div class='btnContainer'>
          <el-button class='searchBtn' size='small' :loading='addLoad' @click='addClick'>确认
          </el-button>
          <el-button class='resetBtn' size='small' @click='dialogClose'>取消</el-button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import { baseUrl } from '@/config/env';
  import divBorder from '@/components/divBorder';
  import {
    deploymentCarList,
    massLossReport,
    reportingCategory,
    taskLicensePlate,
  } from '@/service/vehiclelog';

  export default {
    components: { divBorder },
    data() {
      return {
        defaultModifyData: {},
        img: [],
        // 页面表单数据
        modifyData: {
          carNum: '',
          shipNum: '',
          taskMode: 0,// 运输方式
          driver: '', // 司机/船长 姓名
          phone: '', // 司机/船长 电话
          massLossTime: '',//质损时间
          typeId: '', // 质损类型 id
          typeName: '', // 质损类型 中文
          partId: '',//质损部位 id
          partName: '',//质损部位 中文
          detailDesc: '',//质损说明
          situation: '',//质损情况
          deployCarList: [], // 质损车选中数据
          attachmentIdStr: '',
        },
        templateSelection: '',
        defaultSearchParams: {},
        searchParams: {
          type: '',
          id: '',
          frameNumber: '',
          page: 1,
          rows: 10,
        },
        tableTotal: 0,
        tableData: [],
        tableLoad: false,  // 质损车加载状态
        selectTable: [],   // 质损车选中数据
        carNumList: [], // 车牌号
        shipNumList: [], // 船号
        massLossType: [], // 质损类型
        massLossPart: [], // 质损部位
        massLossData: {}, // 运单编号接口返回的数据
        uploadUrl: '',  // 上传图片地址
        dialogImageUrl: '',  // 图片地址
        dialogVisible: false,   // 图片
        addLoad: false,   // 确认按钮状态
        rules: {
          taskMode: {
            required: true,
            message: '请选择运输方式',
            trigger: 'blur',
          },
          carNum: {
            required: true,
            message: '请选择车牌号',
            trigger: 'blur',
          },
          shipNum: {
            required: true,
            message: '请选择船名',
            trigger: 'blur',
          },
          massLossTime: {
            required: true,
            message: '请选择质损时间',
            trigger: 'blur',
          },
          typeId: {
            required: true,
            message: '请选择质损类型',
            trigger: 'blur',
          },
          partId: {
            required: true,
            message: '请选择质损位置',
            trigger: 'blur',
          },
          detailDesc: {
            required: true,
            message: '请输入质损部位详细说明',
            trigger: 'blur',
          },
          situation: {
            required: true,
            message: '请输入质损情况',
            trigger: 'blur',
          },
          frameNum: {
            required: true,
            message: '请输入车架号',
            trigger: 'blur',
          },
          img: {
            message: '请上传图片',
            trigger: 'blur',
          },
        },
      };
    },
    mounted() {
      this.defaultModifyData = JSON.parse(JSON.stringify(this.modifyData));
      this.defaultSearchParams = JSON.parse(JSON.stringify(this.searchParams));
      this.uploadUrl = baseUrl + '/web/attachmentFtp/upload';
      this.getOptions(0);
      this.getOptions(1);
      this.getReportingCategory();
    },
    methods: {
      singleElection(row) {
        this.templateSelection = row.id;
        this.modifyData.deployCarList = this.tableData.filter((item) => item.id === row.id);
      },
      resetForm(val) {
        this.modifyData = JSON.parse(JSON.stringify(this.defaultModifyData));
        this.searchParams = JSON.parse(JSON.stringify(this.defaultSearchParams));
        this.tableData = [];
        this.tableTotal = 0;
        this.img = [];
        this.modifyData.taskMode = val;
      },
      setDriverInfo() {
        switch (this.modifyData.taskMode) {
          case 0 :
            this.modifyData.driver = this.carNumList.filter(item => item.id === this.modifyData.carNum)[0].driverName;
            this.modifyData.phone = this.carNumList.filter(item => item.id === this.modifyData.carNum)[0].driverTel;
            this.searchParams.id = this.carNumList.filter(item => item.id === this.modifyData.carNum)[0].id;
            break;
          case 1 :
            this.modifyData.driver = this.shipNumList.filter(item => item.id === this.modifyData.shipNum)[0].captainName;
            this.modifyData.phone = this.shipNumList.filter(item => item.id === this.modifyData.shipNum)[0].captainTel;
            this.searchParams.id = this.shipNumList.filter(item => item.id === this.modifyData.shipNum)[0].id;
            break;
        }
      },
      // 获取车牌号/船名数据
      async getOptions(type) {
        const {
          status,
          message,
          data,
        } = await taskLicensePlate(type);
        if (status !== 0) return this.$message.warning(message);
        type ? this.shipNumList = data : this.carNumList = data;
      },
      // 获取车牌号/船名数据
      async getReportingCategory() {
        const {
          status,
          message,
          data,
        } = await reportingCategory();
        if (status !== 0) return this.$message.warning(message);
        console.log(data);
        this.massLossType = data.type;
        this.massLossPart = data.position;
        // type ? this.shipNumList = data : this.carNumList = data;
      },
      /***********
       * 图片上传
       */
      // 上传文件之前的钩子(参数为上传的文件)
      beforeAvatarUpload(file) {
        const TypeArr = ['image/jpeg', 'image/png', 'image/bmp', 'image/gif', 'image/jpg'];
        const isJPG = TypeArr.includes(file.type);
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isJPG) this.$message.error('上传图片只能为jpg/png/jpeg/bmp/gif格式');
        if (!isLt10M) this.$message.error('上传图片大小不能超过 10MB');
        return isJPG && isLt10M;
      },
      // 文件状态改变时
      uploadChange(file, fileList) {
        this.img = fileList;
      },
      // 文件列表移除文件时的钩子
      handleRemove(file, fileList) {
        this.img = fileList;
      },
      // 点击文件列表中已上传的文件时的钩子
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      // 质损车查询
      async searchBtn() {
        this.searchParams.type = this.modifyData.taskMode;
        this.tableLoad = true;
        const {
          status,
          message,
          data,
        } = await deploymentCarList(this.searchParams);
        this.tableLoad = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data.records;
        this.tableTotal = data.total;
      },
      contractSizeChange(row) {
        this.searchParams.rows = row;
        this.searchBtn();
      },
      contractCurrentChange(page) {
        this.searchParams.page = page;
        this.searchBtn();
      },
      // 质损车 删除
      deleteClick() {
      },
      // 质损车选择
      handleSelectionChange(val) {

      },
      // 取消按钮
      dialogClose() {
        this.$refs.ruleForm.resetFields();
      },
      // 确认按钮
      async addClick() {
        await this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            let imgStr = [];
            if (this.img && this.img.length > 0) {
              this.img.forEach(item => {
                if (item.response && item.response.status == 0) {
                  imgStr.push(item.response.data.id);
                }
              });
            }
            this.modifyData.typeName = this.massLossType.filter(item => item.id === this.modifyData.typeId)[0].classaName;
            this.modifyData.partName = this.massLossPart.filter(item => item.id === this.modifyData.partId)[0].classaName;
            this.modifyData.attachmentIdStr = imgStr.join(','); // 附件图片idx
            this.addLoad = true;
            const res = await massLossReport(this.modifyData);
            this.addLoad = false;
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.resetForm(this.modifyData.taskMode);
          } else {
            return false;
          }
        });
      },
    },
  };
</script>

<style lang='scss' scoped>
  .massLoss-report {
    color: #606266;
    max-height: calc(100% - 30px);
    overflow-y: auto;

    ::v-deep .baseInfo {
      width: 900px;
      display: block;
      margin: 0 auto;
      flex-direction: column;

      &Content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px 23px 0 23px;
        font-size: 14px;

        .el-form-item__label {
          font-weight: 700;
        }

        .el-input {
          width: 570px;
        }

        .el-textarea {
          width: 570px;
        }

        .yang {
          .el-form-item {
            margin-bottom: 15px;
          }

          .inforShow {
            .el-form-item {
              .el-form-item__label {
                line-height: 25px;
              }

              .el-form-item__content {
                line-height: 25px;
              }
            }
          }

        }

        .zhisun {
          .el-form-item {
            margin-bottom: 0px;
          }

        }

        .el-upload-list__item {
          width: 100px;
          height: 100px;
        }

        .el-upload--picture-card {
          width: 100px;
          height: 100px;
          line-height: 100px;
        }

        .imgUp {
          display: flex;
          flex-direction: column;

          .imgLength {
            display: flex;
            align-items: center;
            width: 100%;

            span {
              margin-left: auto;
              color: rgb(183, 183, 183);
              font-size: 16px;
            }
          }
        }
      }
    }

    .btnContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 13px;
      margin-top: 20px;

      button {
        margin: 0 15px;
      }
    }
  }

  ::v-deep {
    .el-form-item__error {
      padding-top: 0px;
    }

    .el-form-item {
      margin-bottom: 18px;
    }

    .el-textarea.el-input--small {
      padding: 4px 0px;
    }

    .el-pagination .el-select .el-input {
      width: 100px;
    }

    .el-pagination__editor.el-input {
      width: 50px !important;
    }

    .car-table {
      .el-radio__label {
        display: none;
      }
    }

    .transportTitle {
      background-color: #f4f7fb;
    }
  }

  .taskMode {
    padding: 15px 10px 0 !important;
  }

  .el-form-item.driver-info {
    margin: -22px 0 0;

    span {
      display: inline-block;
      width: 50%;
    }
  }

  .el-form-item.ship-info {
    margin: -15px 0 0;

    span {
      display: inline-block;
      width: 50%;
    }
  }

  .taskMode.div-border {
    padding: 20px 10px 30px !important;
  }

  .car-input.el-input.el-input--small {
    width: 200px !important;
    margin-right: 20px;
  }

  .el-table.car-table {
    width: 100%;
  }

</style>
